import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

const fieldTypeEnum = {
  Text: 'STRING',
  Dropdown: 'ARRAY_MULTIPLE',
  'Text Area': 'TEXT_AREA',
  Number: 'NUMBER',
  Date: 'DATE',
  Attachment: 'ATTACHMENT',
};

interface Request {
  data: any;
  sectionId: PilotId;
}
export const createDataField = ({ data, sectionId }: Request) => {
  return pilot.post('document-information-fields/', {
    allow_multiple: data.allow_multiple,
    allow_new_options: data.allow_new_options,
    section_id: sectionId,
    default: data.defaultValue,
    doc_types: data.doc_types
      ? data.doc_types.map((item: any) => item.value)
      : [],
    doc_restriction: data.doc_restriction,
    // @ts-ignore
    field_type: fieldTypeEnum[data.field_type.value],
    help_text: data.help_text,
    name: data.name,
    options: data.options.map((option: any) => option.value),
    show_on_upload_form: data.show_on_upload_form,
    sort_options: data.sort_options,
  });
};
